module.exports = __webpack_public_path__ + "static/media/icon_locker.aa74fe97.svg";